module.exports = __webpack_public_path__ + "img/quality.2546aeac.png";